import { IP_INFO_TOKEN } from '@/modules/common';

interface GeoData {
  ip: string;
  asn: string;
  as_name: string;
  as_domain: string;
  country_code: string;
  country: string;
  continent_code: string;
  continent: string;
}

export const getIP = async (): Promise<{ ip: string }> => {
  const res = await fetch('https://api.ipify.org?format=json');
  if (!res.ok) {
    throw new Error('Failed to fetch IP address');
  }
  return await res.json();
};

export const getIPInfo = async (ip: string): Promise<GeoData> => {
  const res = await fetch(`https://api.ipinfo.io/lite/${ip}?token=${IP_INFO_TOKEN}`);
  if (!res.ok) {
    throw new Error('Failed to fetch Geolocation');
  }
  return await res.json();
};

export const getGeolocation = async (): Promise<GeoData> => {
  const { ip } = await getIP();
  if (ip) {
    return await getIPInfo(ip);
  }
  return {
    ip: '',
    asn: '',
    as_name: '',
    as_domain: '',
    country_code: '',
    country: '',
    continent_code: '',
    continent: '',
  };
};
